// DraggableDialogPaper.jsx
import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";

function DraggableDialogPaper(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default DraggableDialogPaper;
